import React from 'react';

function EditSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4352 1.00015C16.6542 0.219106 15.3878 0.219106 14.6068 1.00015L6.83711 8.76983C6.65083 8.9561 6.50319 9.17734 6.40267 9.42084L5.4083 11.8294C4.72922 13.4743 6.37526 15.1204 8.02016 14.4413L10.4287 13.4469C10.6722 13.3464 10.8935 13.1987 11.0797 13.0125L18.8494 5.24279C19.6305 4.46175 19.6305 3.19542 18.8494 2.41437L17.4352 1.00015ZM16.021 2.41437L17.4352 3.82858L16.021 5.24279L14.6068 3.82858L16.021 2.41437ZM13.1926 5.24279L14.6068 6.65701L9.66553 11.5983L7.25695 12.5926L8.25132 10.184L13.1926 5.24279Z"
      />
      <path d="M3 2C1.34315 2 0 3.34315 0 5V17C0 18.6569 1.34315 20 3 20H15C16.6569 20 18 18.6569 18 17V13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13V17C16 17.5523 15.5523 18 15 18H3C2.44772 18 2 17.5523 2 17V5C2 4.44772 2.44772 4 3 4H7C7.55228 4 8 3.55229 8 3C8 2.44772 7.55228 2 7 2H3Z" />
    </svg>
  );
}

export default EditSVG;
